import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const FeatureImageSection = ({ 
  image, 
  preTitle, // <-- NEW: For the small text like "ICED"
  title, 
  subtitle, // <-- NEW: For the "MADE BY GRAMS" text
  text, 
  buttonText, 
  buttonLink,
  layout = 'left' // <-- NEW: Prop to control the layout, defaults to 'left'
}) => {
  return (
    // The new modifier class is added here: `feature-image-section--${layout}`
    <section className={`feature-image-section feature-image-section--${layout}`}>
      
      <div 
        className="feature-image-section__background" 
        style={{ backgroundImage: `url(${image})` }} 
      >
        <div className="feature-image-section__overlay"></div>
      </div>

      <div className="feature-image-section__content">
        {/* We conditionally render the new text elements */}
        {preTitle && <h3 className="feature-image-section__pre-title">{preTitle}</h3>}
        <h2 className="feature-image-section__title">{title}</h2>
        {subtitle && <p className="feature-image-section__subtitle">{subtitle}</p>}
        <p className="feature-image-section__text">{text}</p>
        
        <Link to={buttonLink} className="feature-image-section__cta">
          {buttonText}
        </Link>
      </div>

    </section>
  );
};

export default FeatureImageSection;